__turbopack_context__.v({
  "recommendation-section__authors": "jKMGgG_recommendation-section__authors",
  "recommendation-section__content": "jKMGgG_recommendation-section__content",
  "recommendation-section__details": "jKMGgG_recommendation-section__details",
  "recommendation-section__icon-container": "jKMGgG_recommendation-section__icon-container",
  "recommendation-section__image": "jKMGgG_recommendation-section__image",
  "recommendation-section__section-title": "jKMGgG_recommendation-section__section-title",
  "recommendation-section__title": "jKMGgG_recommendation-section__title",
});
